import React from 'react'

import { useTranslation } from 'react-i18next'
import ContentLoader from 'react-content-loader'

const ListLoader = () => {
  const { t } = useTranslation()

  return (
    <ContentLoader
      speed={2}
      width='100%'
      height={300}
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
      title={t('loading')}
    >
      <rect x='18' y='0' rx='0' ry='0' width='98%' height='80' />
      <rect x='18' y='100' rx='0' ry='0' width='98%' height='80' />
      <rect x='18' y='200' rx='0' ry='0' width='98%' height='80' />
    </ContentLoader>
  )
}

export default ListLoader
